import actions from "./actions";

const initState = {
  user: {},
  formLoading: false,
  errorMessage: null,
  userUpdated: false,
  loading: false,
};

export default function createUserReducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_USER_REQUESTED:
      return {
        ...state,
        user: {},
        formLoading: true,
      };
    case actions.CREATE_USER_SUCCEEDED:
      return {
        ...state,
        user: action.user,
        formLoading: false,
        userUpdated: !state.userUpdated,
      };
    case actions.CREATE_USER_FAILED:
      return {
        ...state,
        formLoading: false,
        errorMessage: action.error,
      };
    case actions.CLEAR_USER:
      return {
        ...state,
        user: {},
      };
    case actions.BLOCK_USER_REQUESTED:
      return {
        ...state,
        userUpdated: !state.userUpdated,
        loading: true,
      };
    case actions.BLOCK_USER_SUCCEEDED:
      return {
        ...state,
        loading: false,
        user: action.user,
      };
    case actions.BLOCK_USER_FAILED:
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
      };
    case actions.UNBLOCK_USER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.UNBLOCK_USER_SUCCEEDED:
      return {
        ...state,
        loading: false,
        userUpdated: !state.userUpdated,
        user: action.user,
      };
    case actions.UNBLOCK_USER_FAILED:
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
      };
    default:
      return state;
  }
}
